import { render, staticRenderFns } from "./WelcomeItem.vue?vue&type=template&id=c97825ec"
import script from "./WelcomeItem.vue?vue&type=script&lang=js"
export * from "./WelcomeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports